module.exports = __webpack_public_path__ + "img/mobile-shortage-modal-img.183f6872.svg";